import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import KycApp from "./KycApp";
import { store } from "./store";
import { queryClient } from "./api/queryClient";
import { initAdTrack } from "./utils/attribution";
import "./locales/i18n";
import "./styles/index.scss";

import { LoadingProvider } from "./context/LoadingContext";

initAdTrack();

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <LoadingProvider>
          <KycApp />
        </LoadingProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
);
